import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_MODAL] (state, payload) {
        state.modal = payload;
    },

    [types.SET_ON_CLOSE_CALLBACK] (state, callback) {
        state.closeModalCallback = callback;
    },

    [types.SET_OPTIONS] (state, options) {
        state.options = options;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/modalWindow/mutations.js